<template>
  <section class="feature-placeholder">
    <div class="placeholder-card">
      <div class="placeholder-icon" aria-hidden="true">
        <i class="el-icon-magic-stick"></i>
      </div>
      <p class="placeholder-category">{{ category }}</p>
      <h2>{{ title }}</h2>
      <p class="placeholder-description">{{ description }}</p>
      <div class="placeholder-status">
        <span></span>
        {{ status }}
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FeaturePlaceholder',
  computed: {
    title() {
      return this.$route.meta.title || '新功能'
    },
    category() {
      return this.$route.meta.category || 'AI 空间设计'
    },
    description() {
      return this.$route.meta.description || '该功能正在规划中，后续开发完成后会直接在当前入口开放。'
    },
    status() {
      return this.$route.meta.status || '功能入口已预留'
    }
  }
}
</script>

<style scoped>
.feature-placeholder {
  min-height: calc(100vh - 72px);
  display: grid;
  place-items: center;
  padding: 40px;
  background:
    radial-gradient(circle at 50% 35%, rgba(27, 126, 76, .08), transparent 30%),
    #f6f8f7;
}

.placeholder-card {
  width: min(560px, 100%);
  padding: 56px 48px;
  border: 1px solid #e6ebe8;
  border-radius: 20px;
  background: rgba(255, 255, 255, .94);
  box-shadow: 0 18px 50px rgba(38, 64, 50, .08);
  text-align: center;
}

.placeholder-icon {
  width: 64px;
  height: 64px;
  display: grid;
  place-items: center;
  margin: 0 auto 24px;
  border-radius: 18px;
  background: #e9f6ef;
  color: #167747;
  font-size: 28px;
}

.placeholder-category {
  margin: 0 0 10px;
  color: #7b8881;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1.5px;
}

h2 {
  margin: 0;
  color: #223129;
  font-size: 28px;
}

.placeholder-description {
  max-width: 420px;
  margin: 16px auto 0;
  color: #7b8580;
  font-size: 14px;
  line-height: 1.8;
}

.placeholder-status {
  width: fit-content;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 28px auto 0;
  padding: 8px 14px;
  border-radius: 999px;
  background: #f3f6f4;
  color: #6f7b74;
  font-size: 12px;
}

.placeholder-status span {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #e8a23a;
}

@media (max-width: 767px) {
  .feature-placeholder { padding: 20px; }
  .placeholder-card { padding: 40px 24px; }
  h2 { font-size: 23px; }
}
</style>
